import {
    HubConnectionBuilder,
    HubConnectionState
} from '@microsoft/signalr';
import { sendLoginInfo } from '../reducers/rxBoxModeReducer';

import { PayloadWrapper } from '../types/PayloadWrapper';

export const createSignalRMiddleware = (url) => {
    return storeApi => {
        let connection = InitConnectionBuilder(url);

        connection.on('ReceiveMessage', (message) => {
            console.log("RECEIVED");
            console.log(message);
            storeApi.dispatch({
                type: "automatpacken/rxBox/SIGNALR_MESSAGE_RECEIVED",
                payload: message
            });
        });

        connection.onreconnecting(() => {
            console.log("DISCONNECTED");
            storeApi.dispatch({
                type: "automatpacken/rxBox/SET_SIGNALR_CONNECTION_STATUS",
                payload: new PayloadWrapper(false)
            });
        });

        connection.onreconnected(() => {
            console.log("RECONNECTED");
            onConnected();
        });

        connection.onclose(() => {
            console.log("CONNECTION CLOSED");
            startConnection(connection, onConnected);
        });

        const onConnected = () => {
            storeApi.dispatch({
                type: "automatpacken/rxBox/SET_SIGNALR_CONNECTION_STATUS",
                payload: new PayloadWrapper(true)
            });
            const state = storeApi.getState();
            const { operatorID, workstationID } = state.loginInfoReducer; 
            const { loggedIn } = state.applicationStateReducer;
            const { stationPaused, loopTeamleader } = state.rxModeReducer;
            const loginInfo = {
                OperatorID: operatorID,
                workstationID: workstationID,
                LoggedIn: loggedIn,
                LRX: false,
                Paused: stationPaused,
                LoopTeamleader: loopTeamleader
            };
            storeApi.dispatch(sendLoginInfo(loginInfo));
        };

        return next => action => {
            if (action.type === "SIGNALR_SEND_MESSAGE") {
                connection.send("sendMessage", action.payload);
                return;
            } else if (action.type === "START_SIGNALR" && connection.state === HubConnectionState.Disconnected) {
                const workstationID = action.payload.value;
                connection.baseUrl = connection.baseUrl + workstationID;
                startConnection(connection, onConnected);
                return;
            }
            return next(action);
        };
    };
};

const startConnection = (connection, callback) => {
    connection.start()
    .then(() => {
        console.log("CONNECTED");
        callback();
    })
    .catch(e => {
       setTimeout(() => startConnection(connection, callback), 5000);
       console.log(`Connection to ${connection.baseUrl} failed: ${e}. Retrying...`); 
    });
};

const InitConnectionBuilder = (url) => {
    const retryTime = 5000;
    const limit = 60 * 1000;
    let connection = new HubConnectionBuilder()
        .withUrl(url)
        .withAutomaticReconnect(
            {
                nextRetryDelayInMilliseconds: retryContext => {
                    if (retryContext.elapsedMilliseconds <= limit) {
                        console.log(`retrying after ${retryContext.elapsedMilliseconds / 1000} seconds`);
                        return retryTime;
                    }
                    console.log(`connection closead after retrying for ${retryContext.elapsedMilliseconds / 1000} seconds`);
                    return null;
                }
            }
        )
        .build();
    return connection;
};